//引入vue-router路由插件
import { createRouter, createWebHistory } from 'vue-router';

const routes=[
        {name:'homePage',path: '/index.html',component: ()=> import("@/view/homePage/index.vue")},
        {name:'privacyPage',path: '/privacypolicy.html',component: ()=> import("@/view/privacyPage/index.vue")},
        {name:'termsPage',path: '/terms.html',component: ()=> import("@/view/termsPage/index.vue")},
        {name:'responsiblegameplayPage',path: '/responsiblegameplay.html',component: ()=> import("@/view/responsiblegameplayPage/index.vue")},
        {name:'sweepstakesrulesPage',path: '/sweepstakesrules.html',component: ()=> import("@/view/sweepstakesrulesPage/index.vue")},
        {name:'faqPage',path: '/faq.html',component: ()=> import("@/view/faqPage/index.vue")},
        { path: '', redirect: '/index.html'}
    ]

  // 创建router实例
const router = createRouter({
    history: createWebHistory(),
    routes,
});


export default router
